export const urlAuth = process.env.REACT_APP_API_URL

export const urls = {
    SELLERS: `${urlAuth}/sellers`
}
